import React from "react";
import "./FlexWrapper.css";

const FlexWrapper = props => (
  <div className={"flex-wrapper " + props.class}>{props.children}</div>
);

export default FlexWrapper;



// WEBPACK FOOTER //
// ./src/system/components/FlexWrapper/index.jsx